
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Button.css'

export default function Button(props : {text: string}) {
    const navigate = useNavigate();

    return <button className='button' role={'button'} onClick={() => navigate("/")}>
        {props.text}
    </button>

}